const SET_INTEGRATION_ID = 'set_integration_id'

export default {
  namespaced: true,
  state: {
    selectedIntegrationId: null
  },
  mutations: {
    [SET_INTEGRATION_ID] (state, casinoId) {
      state.selectedIntegrationId = casinoId;
    },
  },
  actions: {
    async setIntegrationId (context, input) {
      context.commit(SET_INTEGRATION_ID, input);
    },
  }
}
